import styled from 'styled-components';
import Lottie from 'lottie-react';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {StatusModal} from '../StatusModal';
import {Modal, ModalTwoButtonsWrapper} from '@guestapp/old-ui-kit';

export const StyledModal = styled(StatusModal)``;

export const StyledFailedModal = styled(Modal)`
  &-content {
    .modal__icon {
      margin-bottom: 10px;
    }
  }

  @media (min-width: ${DEVICE.mobileXL}) {
    &-content {
      max-width: 487px;
      max-height: 790px;
      width: 100%;
      height: auto;

      & .modal__title {
        flex: auto;
      }
    }
  }
`;

export const ModalTwoButtons = styled(ModalTwoButtonsWrapper)`
  margin-top: 48px;
  margin-bottom: 15px;

  @media (min-width: ${DEVICE.mobileXL}) {
    margin-bottom: 0;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 295px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 85%;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${DEVICE.mobileXL}) {
    margin: auto auto 0;
    display: block;
  }
`;

export const ReasonsBlock = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: 15px;
  text-align: left;
`;

export const ReasonItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;

  & > p {
    margin: 0 0 0 10px;
  }
`;

export const FailedModalButtonsContainer = styled.div``;

export const StyledLottie = styled(Lottie)`
  display: block;
  margin: 40px auto 0;
  max-width: 224px;
  height: 225px;

  @media screen and (max-height: 740px) {
    max-width: 140px;
    margin-top: 0;
  }

  @media (min-width: ${DEVICE.mobileXL}) {
    margin-top: 0;
  }
`;
